import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { CONSTANT_NAME, tableConfig } from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";

// type = unit_entri || service || service_non_kpb
export default class LaporanMTD extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      menuName: null,
      search: {},
    };
  }

  componentDidMount() {
    this.setState({
      menuName: this.getTitle(),
    });
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props?.kodeCabang;
    const prevCabang = prevProps?.kodeCabang;
    const currSearch = this.props?.doSearch;
    const prevSearch = prevProps?.doSearch;

    if (
      JSON.stringify(currCabang) !== JSON.stringify(prevCabang) ||
      (currSearch && currSearch !== prevSearch)
    ) {
      this.fetchData();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handlePrint = async () => {
    const { onTriggerLoading, type, setError } = this.props;
    const { dataTable } = this.state;

    const title =
      type === "service"
        ? "Laporan Service MTD"
        : type === "unit_entri"
          ? "Laporan Unit Entri MTD By Cabang"
          : "Laporan Service Non KPB MTD";

    const fileName = title.split(" ").join("_");

    const reqBody = {
      filename: fileName,
      sheets: [
        {
          name: title,
          headers: tableConfig.map((item) => item.label),
          data: dataTable.map((item, index) => ({
            " ": item.name,
            "Last Month": item.lastMonth,
            "This Month": item.thisMonth,
            Growth: item.growth,
            Proyeksi: item.proyeksi,
          })),
        },
      ],
    };
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan MTD",
      args: reqBody,
    });

    onTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName + ".xlsx");
    }
  };

  getTitle = () => {
    const { type } = this.props;
    let title = null;
    switch (type) {
      case "service":
        title = "LAPORAN SERVICE MONTH TO DATE";
        break;
      case "unit_entri":
        title = "LAPORAN UNIT ENTRI MONTH TO DATE BY CABANG";
        break;
      case "service_non_kpb":
        title = "LAPORAN UNIT SERVIS NON KPB MONTH TO DATE BY CABANG";
        break;

      default:
        title = null;
        break;
    }
    return title;
  };

  fetchData = () => {
    const { type } = this.props;
    if (type === "service") {
      return this.fetchDataServiceMTD();
    }
    if (type === "unit_entri") {
      return this.fetchDataUnitEntriMTDByCabang();
    }
    return this.fetchDataUnitServisNonKpbMTD();
  };

  fetchDataServiceMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year, month } = this.state;

    if (!kodeCabang) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanServisMTDH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Service MTD",
      args: {
        listCabang: kodeCabang,
        year: year?.value,
        month: month?.value,
        mechanicEmployeeId: null,
      },
    });

    onTriggerLoading();
    onSuccess();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || {};
      this.setState({
        dataTable: Object.entries(data).map(([key, value]) => ({
          name: CONSTANT_NAME[key] || "",
          ...value,
        })),
      });
    }
  };

  fetchDataUnitEntriMTDByCabang = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year, month } = this.state;

    if (!kodeCabang) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitEntriMTDByCabangH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Unit Entri MTD By Cabang",
      args: {
        listCabang: kodeCabang,
        year: year?.value,
        month: month?.value,
      },
    });

    onTriggerLoading();
    onSuccess();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      console.log(data);
      this.setState({
        dataTable: data?.map((item) => {
          const { cabang, ...rest } = item;
          return {
            ...rest,
            name: cabang,
          };
        }),
      });
    }
  };

  fetchDataUnitServisNonKpbMTD = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year, month } = this.state;

    if (!kodeCabang) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitServisNonKpbMTD,
      setError: setError,
      menuName:
        "Dashboard Kabeng Keatas - Laporan Unit Servis Non KPB MTD By Cabang",
      args: {
        listCabang: kodeCabang,
        year: year?.value,
        month: month?.value,
      },
    });

    onTriggerLoading();
    onSuccess();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState({
        dataTable: data?.map((item) => {
          const { cabang, ...rest } = item;
          return {
            ...rest,
            name: cabang,
          };
        }),
      });
    }
  };

  handleSearch = () => {
    this.fetchData()
  }

  render() {
    const { month, year, dataTable, menuName } = this.state;
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <p className="margin-bottom-20px">{menuName}</p>
        <SimpleDataTable
          data={dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
